let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("72D8w")).then(() => parcelRequire('68CUZ'));